import { Injectable, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { Subject, takeUntil } from 'rxjs';
import { DIALOG_INFO_COMPONENT_MAP } from '../dialog-info-component-map';
import { InfoDialogComponent } from '../controller/info-dialog.component';

export const QUERY_KEY = 'info-dialog';

@Injectable({
    providedIn: 'root'
})
export class InfoDialogListenerService implements OnDestroy {
    private destroy$ = new Subject<void>();

    private initialized = false;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private dialog: MatDialog
    ) {}

    public init(): void {
        if (this.initialized) {
            return;
        }

        this.initialized = true;

        this.route.queryParams
            .pipe(takeUntil(this.destroy$))
            .subscribe(params => {
                const dialogKey = params[QUERY_KEY];

                if (!dialogKey) {
                    return;
                }

                const dialogData = DIALOG_INFO_COMPONENT_MAP[dialogKey];

                if (!dialogData) {
                    this.clearUrl();

                    return;
                }

                const dialogRef = this.dialog.open(InfoDialogComponent, {
                    data: dialogData,
                    panelClass: QUERY_KEY
                });

                dialogRef.afterClosed()
                    .pipe(takeUntil(this.destroy$))
                    .subscribe(() => {
                        this.clearUrl();
                    });
            });
    }

    private clearUrl(): void {
        this.router.navigate([], {
            queryParams: {
                [QUERY_KEY]: null
            },
            queryParamsHandling: 'merge'
        });
    }

    public destroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
        this.initialized = false;
    }

    public ngOnDestroy(): void {
        this.destroy();
    }
}
